module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isCodeArive === false) ? _c('div', {
    staticClass: "auth-form"
  }, [_c('div', {
    staticClass: "text-center logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/password_reminder')))]), _vm._v(" "), (_vm.errorWithLogout) ? [_c('div', {
    staticClass: "w5-field text-center alert alert-danger margin-20-0"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.errorWithLogout),
      expression: "errorWithLogout"
    }],
    staticStyle: {
      "margin": "0",
      "padding": "10px"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logOut($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/logout')))])] : _vm._e(), _vm._v(" "), (!_vm.errorWithLogout) ? [_c('fieldset', {
    attrs: {
      "disabled": _vm.form_Loading
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successMessage === false),
      expression: "successMessage === false"
    }],
    staticClass: "w5-field"
  }, [_c('span', {
    staticClass: "al",
    class: {
      animated: _vm.animatedEmail, focused: _vm.isFocusedEmail, unfocused: !_vm.isFocusedEmail
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/email'))), _c('span', {
    staticClass: "required-field"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "email",
    class: {
      haserror: _vm.form_ErrorMessage
    },
    attrs: {
      "type": "text",
      "aria-describedby": "emailHelp",
      "placeholder": _vm._f("ftc")("main/email *")
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "focus": _vm.OnFocus,
      "blur": _vm.OnBlur,
      "keyup": _vm.OnKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form_ErrorMessage !== false),
      expression: "form_ErrorMessage !== false"
    }, {
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.form_ErrorMessage)),
      expression: "localeFtc(form_ErrorMessage)"
    }],
    staticClass: "alert alert-danger w5-error-block",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "role": "alert"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successMessage === false),
      expression: "successMessage === false"
    }],
    staticClass: "w5-field text-center"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form_Loading),
      expression: "form_Loading"
    }],
    attrs: {
      "src": "/static/img/loading32.gif"
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.form_Loading),
      expression: "!form_Loading"
    }],
    ref: "button",
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.request
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/remind')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successMessage !== false),
      expression: "successMessage !== false"
    }],
    staticClass: "w5-field text-center alert alert-success margin-20-0"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.successMessage),
      expression: "successMessage"
    }],
    staticStyle: {
      "margin": "0",
      "padding": "10px"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.form_Loading),
      expression: "!form_Loading"
    }],
    staticClass: "w5-field"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successMessage === false),
      expression: "successMessage === false"
    }]
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/remembered')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/enter')))])], 1)] : _vm._e()], 2) : _c('div', {
    staticClass: "user-forget-form"
  }, [_c('h2', [_vm._v(_vm._s(_vm._f("ftc")('forget/title')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCodeError !== ''),
      expression: "isCodeError !== ''"
    }],
    staticClass: "alert alert-danger code-error",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.isCodeError)),
      expression: "localeFtc(isCodeError)"
    }]
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successMessage !== '' && _vm.successMessage !== false),
      expression: "successMessage !== '' && successMessage !== false"
    }],
    staticClass: "alert alert-success code-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.successMessage)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-left code-link"
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/return_to_main_page1')) + " "), _c('a', {
    attrs: {
      "href": "/",
      "title": _vm._f("ftc")('login/return_to_main_page2')
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/return_to_main_page2')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24af5936"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Remember.vue
// module id = 448
// module chunks = 0